export const ESTONIAN = "et"
export const LATVIAN = "lv"
export const RUSSIAN = "ru"
export const LITHUANIAN = "lt"
export const ENGLISH = "en"
export const ENGLISH_US = "en-US"
